import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HTTP_INTERCEPTORS, HttpEvent, HttpErrorResponse } from "@angular/common/http";
import { AuthService } from "src/app/services/auth.service";
import { catchError, Observable, retry, throwError, timer } from "rxjs";

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {
  constructor(private auth: AuthService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let request: any = req;

    if (this.auth.user && this.auth.user.token) {
      request = req.clone({
        setHeaders: {
          Authorization: `Bearer ${this.auth.user.token}`,
        },
      });
    }

    // return next.handle(request);

    return next.handle(request).pipe(
      retry({
        count: 3,
        delay: (err, retryCount) => {
          switch (err.status) {
            case 408:
            case 500:
            case 502:
            case 503:
            case 504:
              return timer(1000 * (retryCount * retryCount));
            default:
              return throwError(() => err);
          }
        },
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 0) {
          // Server not responding, connection lost?
        }
        return throwError(() => error);
      })
    );
  }
}
